export default {"src":"/_next/static/media/ucsr-logo.b390d051.svg","height":43,"width":254,"blurWidth":0,"blurHeight":0};